module.exports = __webpack_public_path__ + "img/digital-footprint.601f309a.svg";